import * as Yup from "yup";
export const stringValidation = Yup.string().required();
